window.Lection.sendHomework = function ($form) {
	var route = $form.attr('action');
	var params = $form.serializeArray();
	var $btn = $form.find('button[type=submit]');

	$btn.text('Отправка..').attr('disabled', 'disabled');

	$.post(route, params, function (data) {
		yaCounterReachGoal('homework-send');

		if (data.error) {
			$btn.text('Отправить').removeAttr('disabled');
			alert('Произошла ошибка. Обновите страницу и попробуйте снова.')
		} else {
			var $container = $form.closest('.homework-send');
			$container.after(data.view);
			$container.remove();

			let $stat = $('#lection-homework .stat');
			if ($stat.length) {
				$([document.documentElement, document.body]).animate({
					scrollTop: $stat.offset().top - 100
				}, 500);
			}

			$('#lection-homework .swiper').each(function (i, e) {
				VGCarousel.init(e);
			});

			$('#lection-homework [data-toggle="tooltip"]').tooltip();
		}
	});
};

window.Lection.cacheHomeworkTimeout = null;
window.Lection.cacheHomework = function ($form) {
	$form = $form || $("#form-homework");

	if (!$form.data('caching'))
		return false;

	var route = $form.attr('data-action-cache');
	var params = $form.serializeArray();

	clearInterval(window.Lection.cacheHomeworkTimeout);
	window.Lection.cacheHomeworkTimeout = setTimeout(function () {
		$.post(route, params, function (data) {

		});
	}, 1000);
};

let hwScrollLocked = false;
window.hwScrollLock = function (x, y) {
	if (!hwScrollLocked) {
		if (y < 100) {
			$(window).scrollTop($(window).scrollTop() - 50);
			hwScrollLocked = true;
			setTimeout(function () {
				hwScrollLocked = false;
			}, 200);
		} else if (y > $(window).height() - 100) {
			$(window).scrollTop($(window).scrollTop() + 50);
			hwScrollLocked = true;
			setTimeout(function () {
				hwScrollLocked = false;
			}, 200);
		}
	}
};

$(document).ready(function () {
	var $formHomework = $("#form-homework");

	$formHomework.submit(function () {
		Lection.sendHomework($(this));
		return false;
	});

	$formHomework.find('textarea.task').on('keyup input', function () {
		var text = $(this).val(),
			matches = text.match(/\n/g),
			breaks = matches ? matches.length + 1 : 1;

		$(this).attr('rows', breaks);
	});

	$(document).on('click', '.btn-clear-homework', function () {
		if (!confirm('Вы действительно хотите решить ДЗ заново? Текущие результаты будут сброшены.')) {
			return false;
		}
	});

	$(document).on('click', '.questions-t .qt .btn-skip-q', function() {
		let $q = $(this).closest('.qt');
		let $input = $q.find('.input-skip');
		$input.val(1);
		$q.addClass('skiped');
		Lection.cacheHomework();
		return false;
	});
	$(document).on('click', '.questions-t .qt .btn-return-skip-q', function() {
		let $q = $(this).closest('.qt');
		let $input = $q.find('.input-skip');
		$input.val(0);
		$q.removeClass('skiped');
		Lection.cacheHomework();
		return false;
	});
});

require('./type-text-answer');
require('./type-variants');
require('./type-comparison');
require('./type-letter-to-word');
require('./type-sort-texts');
require('./type-text-words');
require('./type-comparison-img');
require('./type-grouping');